import { IAppState } from '../../../../../AppModulesWrapper';

export const selectIsRecommendedPackagesAvailable = (state: IAppState): boolean => {
  return state.servicePickerWidgetV2.recommendedPackages.packages.length > 0;
};
